<template>
    <b-modal ref="mdlFlussiView" :title="title" hide-header-close no-close-on-backdrop no-close-on-esc centered scrollable>
        <div class="b-table-sticky-header">
            <b-table sticky-header ref="table" stacked="lg" striped hover :items="jsonData.listaDettagli" :fields="fields" :current-page="1" :per-page="1000000" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                <template #cell(index)="row">
                    {{ row.index + 1 }}
                </template>
                <template #cell(meseRiferimento)="{ item }">
                    {{ formatDateTimeCustom(item.meseRiferimento, "MMM-yyyy") }}
                    <!-- {{ formatDateTime(item.meseRiferimento) }} -->
                </template>
                <template #cell(statoAttualeDataOra)="{ item }">
                    {{ formatDateTime(item.statoAttualeDataOra) }}
                </template>
                <template #cell(actions)="{ item }">
                    <b-container class="bv-example-row">
                        <b-button size="sm" v-b-tooltip.hover title="Visualizza Dettaglio" variant="outline-secondary" @click="onDownload(item)">
                            <b-icon icon="download"></b-icon>
                        </b-button>
                    </b-container>
                </template>
            </b-table>
        </div>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>

<script>
import axios from "axios";
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import UtilityMixin from "../../utility/UtilityMixin";

export default {
    mixins: [UtilityMixin],
    components: { ModalError },
    data() {
        return {
            title: null,
            pathResource: "/flussitestata",
            pathResourceDettaglio: "/flussilogdettagli",
            idRisorsa: null,
            readOnly: false,
            listKey: 0,
            jsonData: {},
            fields: [
                {
                    label: "*",
                    key: "index",
                },
                {
                    label: "Tipo",
                    key: "tipoFlusso",
                },
                {
                    label: "Stato Attuale",
                    key: "statoAttuale",
                },
                {
                    label: "Data/Ora",
                    key: "statoAttualeDataOra",
                },
                {
                    label: "",
                    class: "sa-table-column-action-double",
                    key: "actions",
                },
            ],
        };
    },
    methods: {
        loadData() {
            let me = this;
            let path = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.idRisorsa;
            UtilityMixin.methods.restCallGet(path, null, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
            me.title = me.jsonData.tipoFile;
            me.$refs.mdlFlussiView.show();
        },
        loadDataError(error) {
            let me = this;
            me.$emit("afterLoadData", error);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        init(id) {
            let me = this;
            me.idRisorsa = id;
            me.loadData();
        },
        onDownload(item) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceDettaglio + "/download/" + item.id;
            axios({
                url: link, //your url
                method: "GET",
                responseType: "blob", // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                let nomeFile = item.nomeFile;
                link.setAttribute("download", nomeFile + ".zip");
                document.body.appendChild(link);
                link.click();
            });
        },
    },
};
</script>

<style></style>
